import { UserRole } from '@modules/auth/models/enums/user-role.enum';
import { SidebarMenuItem } from '../models';

/**
 * Statyczne elementy menu które są zawsze widoczne (nie z backendu)
 */
export const STATIC_MENU_ITEMS: SidebarMenuItem[] = [
    {
        label: 'layout.sidebar.menu.dashboard',
        icon: 'pi pi-home',
        route: '/dashboard/overview',
        active: true
    },
    {
        label: 'layout.sidebar.menu.your-objects',
        icon: 'pi pi-building',
        route: '/objects/list',
        active: true
    },
    {
        label: 'layout.sidebar.menu.calendar',
        icon: 'pi pi-calendar',
        route: '/calendar',
        active: true
    },
    {
        label: 'layout.sidebar.menu.conversations',
        icon: 'pi pi-comments',
        route: '/conversations',
        active: true
    },
    {
        label: 'layout.sidebar.menu.tasks',
        icon: 'pi pi-check-square',
        route: '/tasks',
        active: true
    },
    {
        label: 'layout.sidebar.menu.cleaning',
        icon: 'pi pi-sparkles',
        route: '/cleaning',
        active: true,
        // Feature planu PRO — widoczne gdy plan nadaje 'cleaning'. super_admin
        // dostaje features.cleaning=true. Backend egzekwuje (@RequiresFeature, 403).
        requiresAnyFeature: ['cleaning']
    },
    {
        label: 'layout.sidebar.menu.calendar-sync',
        icon: 'pi pi-sync',
        route: '/calendar-sync',
        active: true,
        // Feature planu PRO — widoczne gdy plan nadaje 'calendarSync'. Backend
        // egzekwuje (@RequiresFeature CALENDAR_SYNC, 403).
        requiresAnyFeature: ['calendarSync']
    },
    {
        label: 'layout.sidebar.menu.guestInfo',
        icon: 'pi pi-qrcode',
        route: '/guest-info',
        active: true,
        // Feature planu PRO — widoczne gdy plan nadaje 'guestInfo'. super_admin
        // dostaje features.guestInfo=true. Backend egzekwuje (@RequiresFeature
        // GUEST_INFO, 403).
        requiresAnyFeature: ['guestInfo']
    },
    {
        // Opinie — feature planu PRO. Wpływają też na bezpłatne pozycjonowanie
        // obiektu (czynnik "opinie"). Backend egzekwuje (@RequiresFeature REVIEWS).
        label: 'layout.sidebar.menu.reviews',
        icon: 'pi pi-star',
        route: '/reviews',
        active: true,
        requiresAnyFeature: ['reviews']
    },
    {
        label: 'layout.sidebar.menu.leads',
        icon: 'pi pi-inbox',
        route: '/leads',
        active: true,
        // Hidden for now — visible to super_admin only while in development.
        requiresRole: [UserRole.SUPER_ADMIN]
    },
    {
        label: 'layout.sidebar.menu.content-generator',
        icon: 'pi pi-sparkles',
        route: '/content-generator',
        active: true
    },
    {
        label: 'layout.sidebar.menu.domains',
        icon: 'pi pi-globe',
        route: '/domains',
        active: true,
        // White-label domains are a paid feature — hidden unless the plan grants
        // a custom subdomain or a custom domain. Backend still enforces (403).
        requiresAnyFeature: ['customSubdomain', 'customDomain'],
        // TEMPORARY: keep the tab super_admin-only while testing white-label.
        // Remove this line to expose it to all entitled users at launch.
        requiresRole: [UserRole.SUPER_ADMIN]
    },
    {
        label: 'layout.sidebar.menu.bot',
        icon: 'pi pi-android',
        route: '/bot',
        active: true,
        // Płatny feature (plan PRO) — ukryty dopóki plan nie nadaje 'bot'.
        // super_admin dostaje features.bot=true z backendu. Backend egzekwuje (403).
        requiresAnyFeature: ['bot'],
        // TEMPORARY: super_admin-only na czas testów — usuń przy launchu.
        requiresRole: [UserRole.SUPER_ADMIN]
    },
    {
        label: 'layout.sidebar.menu.embed',
        icon: 'pi pi-code',
        route: '/embed',
        active: true,
        // Widget kalendarza do osadzania — feature 'embed' (na start poza
        // planami; super_admin dostaje features.embed=true). Backend egzekwuje
        // (@RequiresFeature EMBED, 403).
        requiresAnyFeature: ['embed'],
        // TEMPORARY: super_admin-only na czas testów — usuń przy launchu
        // (razem z roleGuard w embed-routing.module.ts).
        requiresRole: [UserRole.SUPER_ADMIN]
    },
    {
        // Marketing has no module yet — kept as a disabled placeholder, visible
        // to super_admin only while in development.
        label: 'layout.sidebar.menu.marketing',
        icon: 'pi pi-megaphone',
        disabled: true,
        requiresRole: [UserRole.SUPER_ADMIN]
    },
    {
        label: 'layout.sidebar.menu.municipal-info',
        icon: 'pi pi-info-circle',
        route: '/municipal-info',
        active: true,
        requiresRole: [UserRole.SUPER_ADMIN]
    },
    {
        label: 'layout.sidebar.menu.settings',
        icon: 'pi pi-cog',
        route: '/settings',
        active: true
    }
];

/**
 * Konfiguracja domyślnych ikon dla elementów menu
 */
export const MENU_ICONS = {
  academy: 'pi pi-building',
  project: 'pi pi-book',
  child: 'pi pi-file'
} as const;
